var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_SERVICECENTERS) &&
    _vm.serviceCenter &&
    _vm.serviceCenter.id
  )?_c('div',[_c('router-link',{attrs:{"to":{ name: 'View ServiceCenter', params: { id: _vm.serviceCenter.id } }}},[_vm._v(" "+_vm._s(`${_vm.serviceCenter.name}`)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }